//  原来的
import React, { useState, useEffect } from "react";
import { CreateCampaignStageEnum } from "../../config";
import { useTranslation } from "react-i18next";
import {
  RightMarkIcon,
  DiqiuIcon,
  DownArrowIcon,
  WarningIcon,
  HeadThinkingIcon,
  DnaChatBotThinkThreeIcon,
} from "@/components/icons";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { Button } from "antd";
import LoadingPrimary from "@/components/LoadingPrimary";

interface Props {
  step?: CreateCampaignStageEnum | string;
  isDone?: boolean;
  list: any;
  influencersFew?: boolean; // 是否是达人不足的情况
  butType?: string; // 有值是要按钮；根据值判断按钮类型
  isShowExpand?: boolean;
  openBreathe?: boolean;
  isShowCountDown?: boolean;
  isShowLoading?: boolean;
}

const ProgressTimeLine: React.FC<Props> = ({
  step,
  isDone,
  list,
  influencersFew,
  butType,
  isShowExpand = false,
  openBreathe = false,
  isShowCountDown = false,
  isShowLoading = true,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [items, setItems] = useState(list || []);
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    setItems(list || []);
  }, [list]);

  // 计时器逻辑
  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (isShowCountDown && !isDone) {
      interval = setInterval(() => {
        setCountdown((prev) => prev + 1);
      }, 1000);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isShowCountDown, isDone]);

  // 当isDone变为true时，重置计时器
  useEffect(() => {
    if (isDone) {
      setCountdown(0);
    }
  }, [isDone]);

  const handleClick = (
    item: {
      stage: string;
      steps: { title: string; body?: string[] }[];
      expand?: boolean;
    },
    index: number
  ) => {
    if (!items[index].steps) {
      return;
    }
    const newItems = [...items];
    newItems[index].expand = !newItems[index].expand;
    setItems(newItems);
  };

  // 根据状态判断 按钮功能
  const getButtonType = (butType: string) => {
    switch (butType) {
      case "editCampaign":
        return (
          <div className="ml-[24px]">
            <Button
              style={{ width: 140 }}
              type="primary"
              onClick={toEditCampaign}
            >
              {t("campaignCreate.progressTimeline.editCampaign")}
            </Button>
          </div>
        );
      default:
        return "";
    }
  };
  // 编辑campaign
  const toEditCampaign = () => {
    navigate(
      `/campaign/create/${CreateCampaignStageEnum.BUSINESS_INFORMATION}?campaignId=${id}&isEdit=1&isActiveEdit=1`
    );
  };

  const [isExpand, setExpand] = useState(true);
  useEffect(() => {
    if (isDone && isShowExpand) {
      setExpand(false);
    }
  }, [isDone]);

  return (
    <div className="w-full p-4 bg-white rounded-[20px] border border-[#EEEEEE] inline-flex flex-col justify-start items-start gap-4">
      {isShowExpand && (
        <div className="flex items-center justify-between w-full">
          {!isDone ? (
            <div className="inline-flex justify-start items-center gap-2">
              <HeadThinkingIcon />
              <div className="justify-start text-orange-600 text-sm font-medium  leading-7">
                {t("campaignCreate.progressTimeline.headThinking")}
              </div>
            </div>
          ) : (
            <div className="inline-flex justify-start items-center gap-2">
              <DnaChatBotThinkThreeIcon className="text-[#15803D]" />
              <div className="justify-start text-[#16A34A] text-sm font-medium  leading-7">
                {t("campaignCreate.progressTimeline.headFinished")}
              </div>
            </div>
          )}
          <div
            className="w-8 h-8 mr-2 flex items-center justify-center bg-white rounded-full shadow-[0px_0px_0px_5px_rgba(217,217,218,0.25)] border border-stone-300 cursor-pointer"
            onClick={() => setExpand(!isExpand)}
          >
            <DownArrowIcon
              className={`w-4 h-4  ${
                isExpand
                  ? "rotate-180 transition-all duration-300"
                  : "transition-all duration-300"
              }`}
            />
          </div>
        </div>
      )}
      {isExpand && (
        <>
          {!items?.length && !isDone ? (
            <div className="w-full flex items-start justify-start gap-2">
              {isShowLoading && (
                <div className="w-[24px] h-[24px]">
                  <LoadingPrimary width={24} height={24} />
                </div>
              )}
              {isShowCountDown && countdown > 0 && (
                <div className="justify-start">
                  <span className="text-font&icon-primary text-xs font-medium font-['DM_Sans'] leading-none">
                    {countdown}s{" "}
                  </span>
                  <span className="text-font&icon-helper text-xs font-medium font-['DM_Sans'] leading-none">
                    / 20s
                  </span>
                </div>
              )}
            </div>
          ) : (
            <div className="flex flex-col gap-4">
              {items?.map(
                (
                  item: {
                    stage: string;
                    steps: { title: string; body?: string[] }[];
                    expand?: boolean;
                  },
                  index: number
                ) => (
                  <div
                    className={`flex flex-col ${
                      item.steps && item?.steps.length > 0 ? "gap-3" : ""
                    }`}
                    key={item?.stage}
                  >
                    <div
                      className="flex justify-start items-center gap-2 cursor-pointer"
                      onClick={() => handleClick(item, index)}
                    >
                      {index === items?.length - 1 && !isDone ? (
                        <div className="w-4 h-4 rounded-[8px] border-[2px] border-[#D9D9E0]"></div>
                      ) : (
                        <div className="w-4 h-4 rounded-[8px] bg-[#FB6011] flex items-center justify-center">
                          <RightMarkIcon className="text-white w-[14px] h-[14px]" />
                        </div>
                      )}
                      <div className="justify-start text-[#1c2024] text-base font-medium  leading-7">
                        {item?.stage}
                      </div>
                      {!!item?.steps?.length && (
                        <DownArrowIcon
                          className={`${
                            item?.expand ? "rotate-180" : ""
                          } transition-all duration-300`}
                        />
                      )}
                    </div>
                    {!item?.expand && !!item?.steps?.length && (
                      <div className="flex flex-col gap-2 pl-6">
                        {item?.steps?.map(
                          (b: { title: string; body?: string[] }) => (
                            <div
                              className="flex items-center gap-2"
                              key={b?.title}
                            >
                              <div className="flex justify-start items-center gap-1">
                                <DiqiuIcon />
                                <div className="justify-start text-[#525252] text-xs font-medium  leading-normal">
                                  {b?.title}
                                </div>
                              </div>
                              <div className="justify-start text-[#525252] text-sm font-normal  leading-normal">
                                {b?.body}
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    )}
                  </div>
                )
              )}
              {(!isDone || openBreathe) && (
                <div className="w-full flex items-start justify-start gap-2">
                  {isShowLoading && (
                    <div className="w-[24px] h-[24px]">
                      <LoadingPrimary width={24} height={24} />
                    </div>
                  )}
                  {isShowCountDown && countdown > 0 && (
                    <div className="justify-start">
                      <span className="text-font&icon-primary text-xs font-medium font-['DM_Sans'] leading-none">
                        {countdown}s{" "}
                      </span>
                      <span className="text-font&icon-helper text-xs font-medium font-['DM_Sans'] leading-none">
                        / 20s
                      </span>
                    </div>
                  )}
                </div>
              )}
              {influencersFew && (
                <div>
                  <div className="flex items-top gap-2">
                    <div className="text-[#7f1d1d] mt-[6px]">
                      <WarningIcon className="w-4 h-4" />
                    </div>
                    <div className="text-[#1c2024] text-base font-medium  leading-7">
                      {t("campaignCreate.progressTimeline.noMoreInfluencers")}
                    </div>
                  </div>
                </div>
              )}
              {butType && getButtonType(butType)}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ProgressTimeLine;
